export { default } from './AccreditationCard';
export type { Props } from './AccreditationCard';
